"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPhoneNumber = isPhoneNumber;
exports.isPhoneNumberStrict = isPhoneNumberStrict;
var awesome_phonenumber_1 = require("awesome-phonenumber");
var prop_1 = __importDefault(require("lodash/fp/prop"));
var startsWith_1 = __importDefault(require("lodash/fp/startsWith"));
var phone_1 = require("./phone");
var PHONE_NUMBER_PATTERNS = [
    // NORTH_AMERICAN_PHONE_NUMBER_PATTERN
    /^(?:1[-. ]?)?\(?([2-9][0-8][0-9])\)?[-. ]?([2-9][0-9]{2})[-. ]?([0-9]{4})$/,
    // AUSTRALIAN_PHONE_NUMBER_PATTERN
    /^(\(0[23478]\)|0[23478])(\s?\d{4}\s?\d{4}|\d{2}\s?\d{3}\s?\d{3})$/,
    // INTERNATIONAL_PHONE_NUMBER_PATTERN
    /^(?=.{6,32}$)\+?[\d().\- ]*\d[\d().\- ]*$/,
];
function isPhoneNumber(phoneNumber) {
    return PHONE_NUMBER_PATTERNS.some(function (pattern) { return pattern.test(phoneNumber); });
}
/**
* Strictly validation. Would exam given phone's country, mobile prefix, line number region etc.
*
* @example
* ```typescript
* isPhoneNumberStrict('+1 (817) 569-8900') // true
* isPhoneNumberStrict('(817) 569-8900') // false
* isPhoneNumberStrict('(817) 569-8900', { regionCode: 'US' }) // true
* ```
* */
function isPhoneNumberStrict(phoneNumber, config) {
    if (config === void 0) { config = {}; }
    var res = (0, awesome_phonenumber_1.parsePhoneNumber)(phoneNumber, config);
    var noPlus = !(0, startsWith_1.default)('+')(phoneNumber);
    if (res.valid && config.regionCode && noPlus) {
        var e164 = (0, prop_1.default)('number.e164')(res);
        var significant = (0, prop_1.default)('number.significant')(res);
        var numberString = phoneNumber.replace(/\D/g, '');
        if (numberString.startsWith('0')) {
            numberString = numberString.substring(1);
        }
        var regionCode = (0, phone_1.lookupRegionCode)(e164);
        return regionCode === config.regionCode && numberString.length === significant.length;
    }
    return res.valid;
}
